export const BusinessSecure = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 2048 2048"
        width="80"
        height="80"
        style={{ enableBackground: 'new 0 0 2048 2048' }}
        xmlSpace="preserve"
      >
        <path style={{ fill: '#465a65' }} d="M448.658 559.285h717.311v718.4H448.658z" />
        <path style={{ fill: '#cfd8dd' }} d="M1274.624 1419.96H340.002c-33.137 0-60-26.863-60-60v-164.55c0-33.137 26.863-60 60-60h934.623c33.137 0 60 26.863 60 60v164.549c-.001 33.138-26.864 60.001-60.001 60.001z" />
        <circle style={{ fill: '#465a65' }} cx="1009.043" cy="1277.681" r="47.226" />
        <circle style={{ fill: '#465a65' }} cx="845.211" cy="1277.681" r="47.226" />
        <path style={{ fill: '#465a65' }} d="M699.082 1265.12H394.525c-13.255 0-24-10.745-24-24s10.745-24 24-24h304.557c13.255 0 24 10.745 24 24s-10.745 24-24 24zM699.082 1338.241H394.525c-13.255 0-24-10.745-24-24s10.745-24 24-24h304.557c13.255 0 24 10.745 24 24s-10.745 24-24 24z" />
        <g>
          <path style={{ fill: '#cfd8dd' }} d="M1274.624 1091.037H340.002c-33.137 0-60-26.863-60-60V866.488c0-33.137 26.863-60 60-60h934.623c33.137 0 60 26.863 60 60v164.549c-.001 33.137-26.864 60-60.001 60z" />
          <circle style={{ fill: '#465a65' }} cx="1009.043" cy="948.763" r="47.226" />
          <circle style={{ fill: '#465a65' }} cx="845.211" cy="948.763" r="47.226" />
          <g>
            <path style={{ fill: '#465a65' }} d="M699.082 936.202H394.525c-13.255 0-24-10.745-24-24s10.745-24 24-24h304.557c13.255 0 24 10.745 24 24s-10.745 24-24 24zM699.082 1009.324H394.525c-13.255 0-24-10.745-24-24s10.745-24 24-24h304.557c13.255 0 24 10.745 24 24s-10.745 24-24 24z" />
          </g>
        </g>
        <g>
          <path style={{ fill: '#cfd8dd' }} d="M1274.624 762.12H340.002c-33.137 0-60-26.863-60-60V537.57c0-33.137 26.863-60 60-60h934.623c33.137 0 60 26.863 60 60v164.55c-.001 33.137-26.864 60-60.001 60z" />
          <circle style={{ fill: '#465a65' }} cx="1172.875" cy="619.845" r="47.226" />
          <circle style={{ fill: '#465a65' }} cx="1009.043" cy="619.845" r="47.226" />
          <circle style={{ fill: '#465a65' }} cx="845.211" cy="619.845" r="47.226" />
          <g>
            <path style={{ fill: '#465a65' }} d="M699.082 607.285H394.525c-13.255 0-24-10.745-24-24s10.745-24 24-24h304.557c13.255 0 24 10.745 24 24s-10.745 24-24 24zM699.082 680.406H394.525c-13.255 0-24-10.745-24-24s10.745-24 24-24h304.557c13.255 0 24 10.745 24 24s-10.745 24-24 24z" />
          </g>
        </g>
        <g>
          <path style={{ fill: '#badb47' }} d="m1454.709 1570.429-20.107-20.904c-4.518-4.697-8.894-9.478-13.125-14.102-7.148-7.811-13.9-15.189-20.957-21.814-11.13-10.448-25.178-19.676-42.946-28.211-8.607-4.138-17.348-8.054-26.604-12.2l-.149-.067c-13.376-5.996-27.208-12.196-41.255-19.341-35.002-17.813-62.902-38.597-85.3-63.544a246.74 246.74 0 0 1-40.01-60.491c-10.394-22.26-17.307-45.732-20.549-69.765-1.199-8.913-1.942-18.434-2.273-29.117l-.014-.444v-.445l.249-296.658 25.169-2.456c102.729-10.023 198.298-51.114 269.1-115.704l18.805-17.155 18.803 17.156c70.781 64.581 166.325 105.67 269.035 115.698l25.167 2.457.25 297.106-.014.444c-.332 10.683-1.075 20.204-2.272 29.106-3.242 24.043-10.156 47.516-20.55 69.776a246.715 246.715 0 0 1-40.01 60.49c-22.399 24.947-50.299 45.731-85.295 63.541-14.056 7.149-27.89 13.351-41.27 19.348l-.133.06c-9.26 4.149-18.002 8.065-26.599 12.198-17.778 8.539-31.826 17.767-42.957 28.216-7.055 6.624-13.807 14.002-20.955 21.812-4.232 4.624-8.608 9.406-13.126 14.103l-20.108 20.907z" />
          <path style={{ fill: '#92ca32' }} d="M1454.709 1444.465c-16.547-14.428-35.989-26.927-59.188-38.069-9.638-4.633-18.896-8.781-28.697-13.172l-.114-.051c-13.051-5.85-25.297-11.339-37.406-17.498-25.192-12.821-44.765-27.21-59.823-43.98a159.244 159.244 0 0 1-25.812-39.02c-6.639-14.218-11.048-29.156-13.103-44.395-.759-5.643-1.252-11.949-1.5-19.218l.183-218.746c82.952-15.935 160.499-49.418 225.489-97.356 64.971 47.929 142.5 81.412 225.43 97.348l.185 218.743c-.248 7.271-.74 13.576-1.504 19.25-2.051 15.215-6.46 30.155-13.101 44.375a159.144 159.144 0 0 1-25.811 39.018c-15.057 16.77-34.629 31.158-59.833 43.985-12.123 6.166-24.385 11.662-37.366 17.48l-.243.109c-9.768 4.376-18.995 8.511-28.613 13.134-23.183 11.135-42.625 23.634-59.173 38.063z" />
          <circle style={{ fill: '#f3f6ff' }} cx="1454.709" cy="1173.839" r="119.133" />
          <path style={{ fill: '#92ca32' }} d="M1438.267 1226.823a23.926 23.926 0 0 1-16.971-7.029l-25.082-25.082c-9.372-9.373-9.372-24.568 0-33.941 9.373-9.373 24.568-9.373 33.941 0l8.111 8.111 40.997-40.997c9.373-9.373 24.568-9.373 33.941 0 9.372 9.373 9.372 24.568 0 33.941l-57.968 57.968a23.92 23.92 0 0 1-16.969 7.029z" />
        </g>
      </svg>
    </>
  );
};

export const FocusForward = () => {
  return (
    <>

      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="80" height="80">
        <circle cx="13" cy="13" r="9" fill="#FFBF42" />
        <path d="M13,22c-4.96,0-9-4.04-9-9s4.04-9,9-9,9,4.04,9,9-4.04,9-9,9Zm0-16c-3.86,0-7,3.14-7,7s3.14,7,7,7,7-3.14,7-7-3.14-7-7-7Z" fill="#D34A4B" />
        <path d="M13,18c-2.76,0-5-2.24-5-5s2.24-5,5-5,5,2.24,5,5-2.24,5-5,5Zm0-8c-1.65,0-3,1.35-3,3s1.35,3,3,3,3-1.35,3-3-1.35-3-3-3Z" fill="#1777BA" />
        <path d="M13.71,12.29,7,5.59V3c0-.55-.45-1-1-1s-1,.45-1,1v2H3C2.45,5,2,5.45,2,6s.45,1,1,1h2.59l6.71,6.71c.19.2.45.29.71.29s.51-.1.71-.29c.39-.39.39-1.02,0-1.41Z" fill="#624F81" />
      </svg>

    </>
  )
}

export const Price = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"
      width="80"
      height="80">
      <g data-name="Price Tag">
        <path d="M28.26 16 22 19.43a2 2 0 0 0-1 1.75V45.4c0 .22 1 .44-10.11-2.54a2 2 0 0 1-1.41-2.45l6.17-23A2 2 0 0 1 17.13 16c9.87-2.53 8.29-2.79 11.13 0z" fill="#6fabe6" />
        <path d="M28.26 16 22 19.43a2 2 0 0 0-1 1.75v21.31l-6.07-1.63a2 2 0 0 1-1.41-2.45l6.17-23c0-.12-.43 0 5.21-1.37 1.36-.36 2.03.63 3.36 1.96z" fill="#82bcf4" />
        <path d="M39 21.18V45a2 2 0 0 1-2 2H23a2 2 0 0 1-2-1.6c-.06-.27 0 1.21 0-24.22 0-1.37 1.07-1.77 2-2.3 6.41-3.57 6.71-4 7.94-3.34l7 3.89A2 2 0 0 1 39 21.18z" fill="#ffcc66" />
        <path d="M39 21.18V44H26a2 2 0 0 1-2-2V18.34c5.41-3 5.76-3.48 7-2.8l7 3.89a2 2 0 0 1 1 1.75z" fill="#ffde76" />
        <path d="M30 34a2 2 0 1 1 2-2 1 1 0 0 0 1 1c1.89 0 1.06-4.06-2-4.86V27a1 1 0 0 0-2 0v1.14A4 4 0 0 0 30 36a2 2 0 1 1-2 2 1 1 0 0 0-1-1c-1.89 0-1.06 4.06 2 4.86V43a1 1 0 0 0 2 0v-1.14A4 4 0 0 0 30 34z" fill="#f8834b" />
        <circle cx="30" cy="21" r="2" fill="#ffba55" />
        <path d="M37.27 15.74c-2 3.17-5.42 5.78-6.4 5.78a1 1 0 0 1-.47-1.88c7-3.71 9.83-14.28 5.58-17S23.39 6.88 22.82 14.55l-2 .5c-.2-.59.28-4.44 2.68-8.18C26.62 2 32.72-1.89 37.06.93c3.86 2.49 3.94 8.99.21 14.81z" fill="#374f68" />
      </g>
    </svg>
  )
}
export const Scalability = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="80" height="80" role="img" aria-labelledby="scalTitle1">

      <rect x="3" y="13" width="3" height="8" rx="0.5" fill="#4caf50" />
      <rect x="9" y="9" width="3" height="12" rx="0.5" fill="#2196f3" />
      <rect x="15" y="5" width="3" height="16" rx="0.5" fill="#673ab7" />
    </svg>
  )
}

export const Accuracy = () => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="80" height="80">
        <path fill="#1E6FB8" d="M32 4 8 14v14c0 16 12 30 24 34 12-4 24-18 24-34V14L32 4z" />
        <path fill="none" stroke="#fff" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"
          d="M22 32l8 8 14-14" />
      </svg>
    </>
  )
}

export const Efficiancy = ()=>{
  return(
       <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="80" height="80" role="img" aria-labelledby="efficiencyChecklist">

                    <rect x="14" y="12" width="36" height="40" rx="2" stroke="#1E6FB8" stroke-width="3" fill="none" />
                    <line x1="24" y1="24" x2="44" y2="24" stroke="#1E6FB8" stroke-width="2" />
                    <line x1="24" y1="34" x2="44" y2="34" stroke="#1E6FB8" stroke-width="2" />
                    <line x1="24" y1="44" x2="44" y2="44" stroke="#1E6FB8" stroke-width="2" />

                    <path d="M16 22l4 4 6-8" stroke="#27AE60" stroke-width="3" fill="none" />
                    <path d="M16 32l4 4 6-8" stroke="#27AE60" stroke-width="3" fill="none" />
                </svg>
  )
}